import request from '../../libs/request';

export default {
  sendContact: (body, siteId) => {
    return request(`api/v1/${siteId}/contato/add`).post({ body });
  },

  sendNewsletter: (queryParams, siteId) => {
    return request(`api/v1/${siteId}/responsysUrl`).get({ queryParams });
  },
};
